import { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { ReactComponent as Instructions } from '../../../../../resources/images/header-icons/instructions.svg';
import useTranslation from '../../../../hooks/translation/useTranslation';
import ExpanderContainer from '../../../components/expanderContainer/ExpanderContainer';
import useQuery from '../../../../hooks/useQuery';
import infoContentList from '../../../../../utils/constants/infoContentList';

const authorizeButtonClass = 'border-0 bg-transparent px-1 lg:text-2sm xl:text-base text-black hover:text-primary ease-out duration-300 cursor-pointer flex gap-[10px] items-center whitespace-nowrap hover-icon';

function DesktopHeaderInfoContent() {
  const query = useQuery();
  const { trans, currentLanguage, configInfo } = useTranslation();
  const [showMenu, setShowMenu] = useState(false);

  const location = useLocation();
  const activeTab = query.get('tab');

  const isGeorgian = configInfo?.countryCode === 'GE';

  return (
    <div
      className="relative"
      onMouseEnter={() => setShowMenu(true)}
      onMouseLeave={() => setShowMenu(false)}
    >
      <NavLink to="info-content" className={`${authorizeButtonClass} nav-link font-big`}>
        <Instructions className="h-5 w-5" />
        {trans('additional_info')}
      </NavLink>
      <div className="absolute right-0">
        <ExpanderContainer expanded={showMenu}>
          <div
            className="bg-white rounded-b-3xl py-6 px-12 flex flex-col gap-4"
          >
            {(isGeorgian ? infoContentList.ge : infoContentList.am).items.map(({
              key, label, labels, Icon, muted, isDefault,
            }) => {
              const isActive = isDefault
                ? ((activeTab === key || !activeTab) && location.pathname === `/${currentLanguage}/info-content`)
                : activeTab === key;
              return (
                <Link
                  key={key}
                  to={`info-content?tab=${key}`}
                  className={`${authorizeButtonClass}${muted ? ' opacity-70' : ''} ${isActive && 'active'}`}
                >
                  {Icon ? <Icon className="w-5 h-5" /> : <div className="h-[2px] bg-primary w-5 " />}
                  {labels ? labels.map((l, i) => (
                    <span key={l}>
                      {i > 0 && '/'}
                      {trans(l)}
                    </span>
                  )) : trans(label)}
                </Link>
              );
            })}
          </div>
        </ExpanderContainer>
      </div>
    </div>
  );
}

export default DesktopHeaderInfoContent;
